import React from 'react';

export default function AuthorList ({authors, limit, searchKey, suffix='et al'}) {

    let list = authors.slice(0, limit || authors.length).map((author, index) => {
        let query = {};
        query[searchKey] = author.trim();
        return ([
            <span key={author}>{author}</span>,
            (index < authors.length - 1 ? ', ' : null)
        ]);
    });
    limit && limit < authors.length && list.push(suffix);
    return (<span className="author-list">
        {list}
    </span>);
}
